import type { Vec2 } from '../../geo/types';

export type FlatTriangle = readonly [Vec2, Vec2, Vec2];

/**
 * The triangles that fill the strip between two upright edges, `left` at the smaller x, each edge
 * listed from the bottom up, wound counter-clockwise in x and y. Every triangle has two corners on
 * one edge and the third on the other, so none has its corners in line however narrow the strip or
 * short a step on its edges.
 */
export function uprightStrip(
  left: readonly Vec2[],
  right: readonly Vec2[],
  i = 0,
  j = 0
): FlatTriangle[] {
  const [leftDone, rightDone] = [i === left.length - 1, j === right.length - 1];
  if (leftDone && rightDone) return [];
  const upLeft = rightDone || (!leftDone && left[i + 1]![1] <= right[j + 1]![1]);
  return upLeft
    ? [[left[i]!, right[j]!, left[i + 1]!], ...uprightStrip(left, right, i + 1, j)]
    : [[left[i]!, right[j]!, right[j + 1]!], ...uprightStrip(left, right, i, j + 1)];
}

/** An upright edge at `x` through the given heights, listed from the bottom up. */
export function upright(x: number, heights: readonly number[]): Vec2[] {
  return heights.map((y): Vec2 => [x, y]);
}
